































































































































































































































































































export default {
  beforeCreate (): void {
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/gh/google/code-prettify@master/loader/run_prettify.js?lang=python&skin=desert'
    )
    plugin.async = true
    document.head.appendChild(plugin)
  }
}
